import { forwardRef, useContext } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

import { PanelContext } from './PanelContext.js';

export type PanelFooterElement = FlexElement;

export interface PanelFooterProps extends FlexProps {}

export const PanelFooter = styled(
  forwardRef<PanelFooterElement, PanelFooterProps>((props, ref) => {
    const ctx = useContext(PanelContext);

    if (!ctx) {
      throw new Error('PanelContent must be used within a Panel.');
    }

    const [{ bottom }] = ctx;

    return (
      <Flex ref={ref} {...props} className={`${props.className} ${!bottom ? 'scolling' : ''}`} />
    );
  })
).withConfig({
  displayName: 'PanelFooter',
})<PanelFooterProps>`
  padding: calc(2 * var(--spacing-padding));
  transition: box-shadow 0.2s ease-in-out;
  padding-top: var(--spacing-padding);
  &.scolling {
    box-shadow: rgba(0, 0, 0, 0.1) 0px -3px 5px -3px, rgba(0, 0, 0, 0.1) 1px -7px 11px -3px;
  }
`;
